<ng-container>
  <ng-content></ng-content>
  <div *ngIf="showLastUpdatedTime" class="float-right">
    <p class="text-gray">
      {{ 'Information updated on' | translate }}:
      {{ lastUpdatedTime | date : 'dd/MM/yy HH:mm:ss' }}
    </p>
  </div>
</ng-container>
